//#region src/vitrine_cover_bottom_block_content.ts
var VitrineCoverBottomBlockContent = /* @__PURE__ */ function(VitrineCoverBottomBlockContent) {
	VitrineCoverBottomBlockContent["Fulfillment"] = "fulfillment";
	VitrineCoverBottomBlockContent["Language"] = "language";
	VitrineCoverBottomBlockContent["Loyalty"] = "loyalty";
	return VitrineCoverBottomBlockContent;
}(VitrineCoverBottomBlockContent || {});
//#endregion
export { VitrineCoverBottomBlockContent };

//# sourceMappingURL=vitrine_cover_bottom_block_content.js.map